export default "__VITE_ASSET__CfCZ9qqR__"